var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkinedHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30.998,
    height: 30.998,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30.998,
    height: 30.998,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_1851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99951 9.14544C7.99951 8.51248 8.52548 7.99951 9.17444 7.99951H22.8236C23.4725 7.99951 23.9985 8.51248 23.9985 9.14544V22.8526C23.9985 23.4855 23.4725 23.9985 22.8236 23.9985H9.17444C8.52548 23.9985 7.99951 23.4855 7.99951 22.8526V9.14544ZM12.9422 21.3927V14.1681H10.5414V21.3927H12.9422ZM11.7423 13.1812C12.5792 13.1812 13.1002 12.6272 13.1002 11.9333C13.0852 11.2243 12.5802 10.6853 11.7583 10.6853C10.9363 10.6853 10.3994 11.2253 10.3994 11.9333C10.3994 12.6272 10.9203 13.1812 11.7263 13.1812H11.7423ZM16.65 21.3927V17.3579C16.65 17.1419 16.666 16.926 16.73 16.772C16.903 16.341 17.2979 15.894 17.9619 15.894C18.8308 15.894 19.1778 16.556 19.1778 17.5279V21.3927H21.5787V17.2489C21.5787 15.0291 20.3947 13.9971 18.8148 13.9971C17.5409 13.9971 16.97 14.6971 16.65 15.1901V15.2151H16.634C16.6393 15.2067 16.6446 15.1984 16.65 15.1901V14.1681H14.2501C14.2801 14.8461 14.2501 21.3927 14.2501 21.3927H16.65Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_1851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.999,
    height: 15.999,
    fill: "white",
    transform: "translate(7.99951 7.99951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkinedHover);
export default __webpack_public_path__ + "static/media/linkined_hover.a0947c1814580e425ed6c3b0222501e0.svg";
export { ForwardRef as ReactComponent };